<template>
  <div class="container-checkin">
    <TheVisiting
      :item="visitCustomer"
      :user="user"
      :location="location"
      @saveSuccess="saveSuccess"
    />

    <GoogleMap :getMarkers="markers" @focusMap="activeDragged" />

    <TheDraggedCustomerV2
      :user="user"
      :location="location"
      :visit="visitCustomer"
      :statusDragged="statusMaps"
      :getCustomers="customers"
      @eventDragged="activeDragged"
      @submit="statusVisit = true"
      @search="searchCustomer"
      @saveSuccess="saveSuccess"
    />
  </div>
</template>

<script>
import GoogleMap from '@/components/v2/checkinout/GoogleMap'
import TheDraggedCustomerV2 from '@/components/v2/checkinout/TheDraggedCustomerV2'
import TheVisiting from '@/components/v2/checkinout/TheVisiting'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    GoogleMap,
    TheDraggedCustomerV2,
    TheVisiting
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user
    })
  },

  data() {
    return {
      statusMaps: true, // [true = click map], [false = focus dragged], [null = normal]
      statusVisit: false, // false = ยังไม่เช็คอิน , true = เช็คอินแล้ว
      customers: [],
      markers: [],
      visitCustomer: null,
      location: null,
      search: ``
    }
  },

  watch: {
    location() {
      this.getCustomer()
    },

    search() {
      this.getCustomer()
    }
  },

  methods: {
    ...mapActions({
      getLocation: 'checkinout/getLocation_V2',
      visitCustomers: 'checkinout/visitCustomers'
    }),

    searchCustomer(value) {
      this.search = value
    },

    activeDragged(param) {
      this.statusMaps = param
      console.log(param)
    },

    getCustomer() {
      const formData = {
        user_id: this.user.id,
        lat_lng: this.location,
        keyword: this.search
      }

      const options = {
        url: `${this.$baseAPINew}/web/?act=list_customer`,
        method: 'POST',
        data: formData
      }

      this.$axios(options).then((res) => {
        this.customers = res.data
        this.formatMarkers()
      })
    },

    formatMarkers() {
      const icon_flag = '/img/icons/pin.png'
      this.markers = this.customers
        .filter((location) => location.lat_lng)
        .map((location) => {
          if (location.lat_lng) {
            let lat_lng = location.lat_lng.split(',')
            let lat = lat_lng[0] ? +lat_lng[0] : 0
            let lng = lat_lng[1] ? +lat_lng[1] : 0
            return { position: { lat: lat, lng: lng }, icon: icon_flag }
          }
        })
    },

    saveSuccess() {
      this.visitCustomers({ user_id: this.user.id }).then((result) => {
        this.visitCustomer = result.length === 0 ? null : result
      })
    }
  },

  mounted() {
    this.$nextTick(function() {
      this.$store.dispatch('setTitle', 'เช็คอิน')
    })

    this.getLocation().then((res) => {
      this.location = res

      this.visitCustomers({ user_id: this.user.id }).then((result) => {
        this.visitCustomer = result.length === 0 ? null : result
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.container-checkin {
  margin-top: 65px;
}
</style>
